var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.$bvModal.show('call-panel-modal')}}},[_c('Icon',{staticClass:"pointer",attrs:{"tooltip":"Painel de senhas"}},[_c('TV',{staticStyle:{"fill":"rgb(127, 145, 210)"}})],1),_c('CallPanelModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }